// extracted by mini-css-extract-plugin
export default {"subtitle":"Xe_C_WVY5rIGdo2mt67U__subtitle___","frameworkTimeline":"nchh0ZtOECEsuevR3yfB__frameworkTimeline___"};